import { Paper, PaperProps, Typography, useTheme } from '@mui/material';
import React from 'react';
import AppCustomIcon from '../features/icon/AppIcon';
import { SxProps } from '@mui/system';
import {
	AppBackgroundTriangleBgDarkBlueSrc,
	AppBackgroundTriangleBgDarkBlueBigSrc,
	AppBackgroundTriangleBgTurquoiseSrc,
	AppBackgroundStars,
	AppBackgroundMarketing,
} from '../features/background/AppBackground';
type CAppPaperProps = PaperProps & {
	title?: string;
	icon?: string;
	displayBackgroundImage?: boolean;
	bgVariant?: null | 'stars' | 'marketing';
};

const CAppPaper = (props: CAppPaperProps) => {
	const { displayBackgroundImage, bgVariant, ...rest } = props;
	const theme = useTheme();

	const darkMode = theme.palette.mode === 'dark' ? true : false;

	let sxBase = {
		height: '100%',
		padding: { xs: '15px', sm: '35px' },
		...props.sx,
	} as SxProps;

	if (props.color === 'primary') {
		sxBase = {
			...sxBase,
			background: `${
				displayBackgroundImage
					? `url(${
							bgVariant === 'stars'
								? AppBackgroundStars
								: bgVariant === 'marketing'
								? AppBackgroundMarketing
								: AppBackgroundTriangleBgDarkBlueSrc
					  }),`
					: ''
			} ${!darkMode ? theme.palette.primary.main : theme.palette.background.paper}`,
			backgroundSize: displayBackgroundImage ? 'auto 100%' : '',
			backgroundRepeat: displayBackgroundImage ? 'no-repeat' : '',
			backgroundPosition: displayBackgroundImage ? 'top right' : '',
			color: 'white',
		} as SxProps;
	} else if (props.color === 'secondary') {
		sxBase = {
			...sxBase,
			background: `${
				displayBackgroundImage
					? `url(${darkMode ? AppBackgroundTriangleBgDarkBlueBigSrc : AppBackgroundTriangleBgTurquoiseSrc}),`
					: ''
			}  ${!darkMode ? theme.palette.secondary.dark : theme.palette.background.paper}`,
			backgroundSize: displayBackgroundImage ? 'auto 100%' : '',
			backgroundRepeat: displayBackgroundImage ? 'no-repeat' : '',
			backgroundPosition: displayBackgroundImage ? 'bottom right' : '',
			color: 'white',
		} as SxProps;
	}

	return (
		<Paper {...rest} sx={sxBase}>
			{props.title ? (
				<Typography component="h2" variant="h2">
					{props.icon ? <AppCustomIcon tag={props.icon} className="icon" /> : ''} {props.title}
				</Typography>
			) : (
				''
			)}
			{props.children}
		</Paper>
	);
};

export default CAppPaper;
